export const SHOW_DATE_FORMAT = "YYYY.MM.DD";
export const SHOW_TIME_FORMAT = "HH:mm";
export const SHOW_DATE_TIME_FORMAT = `${SHOW_DATE_FORMAT} ${SHOW_TIME_FORMAT}`;
